import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function WebCamIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.647 14h4.706M13 7.1c0 2.817-2.239 5.1-5 5.1S3 9.917 3 7.1 5.239 2 8 2s5 2.283 5 5.1m-3.125 0c0 1.056-.84 1.912-1.875 1.912S6.125 8.156 6.125 7.1 6.965 5.188 8 5.188s1.875.856 1.875 1.912" /></svg>
  );
}

export default WebCamIcon;
